import React from 'react';
import { Settings, User } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="bg-white border-b border-gray-100 px-6 py-3 sticky top-0 z-40" data-id="element-193">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-194">
        <Link to="/stickers" className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-195">
          Stick Your Logo Here
        </Link>

        <div className="flex items-center gap-4" data-id="element-196">
          <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-50" data-id="element-197">
            <Settings size={20} data-id="element-198" />
          </button>
          <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-50" data-id="element-199">
            <User size={20} data-id="element-200" />
          </button>
        </div>
      </div>
    </header>;
}